// extracted by css-extract-rspack-plugin
export default {"spinnerContainer":"_3363ed0f"};